import { render, staticRenderFns } from "./RuleCard.vue?vue&type=template&id=44620eef&"
import script from "./RuleCard.vue?vue&type=script&lang=js&"
export * from "./RuleCard.vue?vue&type=script&lang=js&"
import style0 from "./RuleCard.vue?vue&type=style&index=0&id=44620eef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports